module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "extended": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": "",
      "loading": _vm.servicesRequest.loading
    },
    on: {
      "click": _vm.reload
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "mr-2",
    attrs: {
      "id": "space-title"
    }
  }, [_vm._v("Spaces")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "outline": "",
      "outlined": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.newspacedialog = true
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" New space\n    ")], 1), _vm._v(" "), _c('template', {
    slot: "extension"
  }, _vm._l((_vm.services), function(service) {
    return _c('v-btn', {
      key: service.id,
      staticClass: "mr-0",
      attrs: {
        "small": "",
        "flat": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.$vuetify.goTo("#space-" + service.id)
        }
      }
    }, [_vm._v(_vm._s(service.title))])
  }), 1)], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "400"
    },
    model: {
      value: (_vm.newspacedialog),
      callback: function($$v) {
        _vm.newspacedialog = $$v
      },
      expression: "newspacedialog"
    }
  }, [_c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.servicesNewRequest
    },
    on: {
      "ok": _vm.newSpaceCreated
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "grey lighten-4 py-0"
  }, [_vm._v("\n        Create a new space\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.newspacedialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Give this space a name"
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.newService.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.spacetitle),
      callback: function($$v) {
        _vm.spacetitle = $$v
      },
      expression: "spacetitle"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.newspacedialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.servicesNewRequest.loading
    },
    on: {
      "click": _vm.newService
    }
  }, [_vm._v("\n          Create\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.servicesRequest,
      "message200": false
    },
    on: {
      "ok": function($event) {
        _vm.newspaceloading = false
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.services), function(service, index) {
    return _c('v-flex', {
      key: service.id,
      attrs: {
        "xs12": "",
        "xl6": ""
      }
    }, [_c('space-settings', {
      key: service.id,
      staticClass: "mb-5",
      attrs: {
        "initially-expanded": _vm.services.length === 1,
        "id": ("service-" + (service.id))
      },
      on: {
        "reload": _vm.reload
      },
      model: {
        value: (_vm.services[index]),
        callback: function($$v) {
          _vm.$set(_vm.services, index, $$v)
        },
        expression: "services[index]"
      }
    })], 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05bb2b87","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/settings/locations/ProductWizard.vue
// module id = 1316
// module chunks = 9